<h1 matDialogTitle>{{ data.title }}</h1>

<div>
  <mat-dialog-content>
    @if (htmlContent) {
      <span>
        <div [innerHTML]="htmlContent"></div>
      </span>
    } @else {
      <p>
        {{ data.content }} <strong>{{ data.name }}</strong>
      </p>
    }
  </mat-dialog-content>

  <mat-dialog-actions>
    <button id="confirm-button-cancel" mat-raised-button data-cy="qe-cancel-message" (click)="cancelAction(true)" mat-dialog-close cdkFocusInitial>
      {{data.cancelLabel ? data.cancelLabel : data.cancelMessage}}
    </button>
    @if (!data?.hideConfirmButton) {
      <button id="confirm-button-ok" mat-raised-button data-cy="qe-okay-message" (click)="confirmAction(true)" color="{{data.buttonType}}">
        {{ data.confirmLabel ? data.confirmLabel : data.okayMessage }}
      </button>
    }
  </mat-dialog-actions>
</div>
